import { Box, useMediaQuery, useTheme } from '@mui/material'

import { BookingAddress } from 'generated/graphql'
import { ConsignmentPair } from 'hooks/booking/useBookingAddresses'

import { DetailedViewHeader, DropOffSection, PackageSection, PickupSection } from './detailed-view'

interface DetailedViewProps {
  onClose: () => void
  bookingCurrentAction?: BookingAddress | null
  nextBookingAction?: BookingAddress | null
  consignmentPairs?: ConsignmentPair[]
}

const contentStyles = {
  p: 2,
}

const mobileContainerStyles = {
  height: '100%',
  display: 'flex',
  flexDirection: 'column' as const,
  minHeight: 0,
}

const webContainerStyles = {
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column' as const,
  minHeight: 0,
}

const scrollContentStyles = {
  flex: 1,
  minHeight: 0,
  overflowY: 'auto' as const,
}

export const DetailedView = ({
  onClose,
  bookingCurrentAction,
  nextBookingAction,
  consignmentPairs,
}: DetailedViewProps) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const renderConsignments = () => {
    if (consignmentPairs && consignmentPairs.length > 0) {
      return consignmentPairs.map(({ collection, deliveries }) =>
        deliveries.length > 0 ? (
          deliveries.map((delivery) => (
            <Box key={`${collection.id}-${delivery.id}`}>
              <PickupSection bookingCurrentAction={collection} />
              <DropOffSection nextBookingAction={delivery} />
              <PackageSection
                pickupAddress={collection}
                dropoffAddress={delivery}
                collectionAddress={collection}
              />
            </Box>
          ))
        ) : (
          <Box key={collection.id}>
            <PickupSection bookingCurrentAction={collection} />
            <PackageSection
              pickupAddress={collection}
              dropoffAddress={null}
              collectionAddress={collection}
            />
          </Box>
        ),
      )
    }

    return (
      <>
        <PickupSection bookingCurrentAction={bookingCurrentAction} />
        {nextBookingAction && <DropOffSection nextBookingAction={nextBookingAction} />}
        <PackageSection pickupAddress={bookingCurrentAction} dropoffAddress={nextBookingAction} />
      </>
    )
  }

  if (isMobile) {
    return (
      <Box sx={mobileContainerStyles}>
        <DetailedViewHeader onClose={onClose} />
        <Box sx={scrollContentStyles}>
          <Box sx={contentStyles}>{renderConsignments()}</Box>
        </Box>
      </Box>
    )
  }

  // Web layout
  return (
    <Box sx={webContainerStyles}>
      <DetailedViewHeader onClose={onClose} />
      <Box sx={scrollContentStyles}>
        <Box sx={contentStyles}>{renderConsignments()}</Box>
      </Box>
    </Box>
  )
}
